import PageHead from "../Head";
import Separator from "@/components/Common/Separator";
import MainDemo from "@/components/01-Main-Demo/01-Main-Demo";
import Cart from "@/components/Header/Offcanvas/Cart";
import { useState, useEffect } from "react";
import { useUser } from "@/context/UserContext";
import ProfileIncompleteModal from "@/components/ProfileIncompleteModal/Modal";

const Home = () => {
  const [showModal, setShowModal] = useState(false);
  const { user } = useUser()


  useEffect(() => {
    const justLoggedIn = localStorage.getItem("login");

    if (justLoggedIn === "true" && user) {
      if (user.profileComplete === false) {
        setShowModal(true);
      }
      localStorage.setItem("login", "false");
    }
  }, [user]);
  return (
    <>
      <PageHead title="Home - Online Courses & Education" />

      <MainDemo />

      <ProfileIncompleteModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default Home;
